'use strict';

var _clientProfilerCore = require('@zillow/client-profiler-core');

var _clientProfilerCore2 = _interopRequireDefault(_clientProfilerCore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Add an event listener that fires a profile call then removes itself
 * @param {*} globalEvent window event name
 * @param {*} metricName name to profile. globalEvent will be used if non is provided
 */
var addProfileEvent = function addProfileEvent(globalEvent) {
    var metricName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : globalEvent;
    var _global = global,
        ClientProfiler = _global.ClientProfiler,
        addEventListener = _global.addEventListener,
        removeEventListener = _global.removeEventListener;

    var fireProfile = function fireProfile() {
        ClientProfiler.profile(metricName);
        removeEventListener(globalEvent, fireProfile);
    };
    addEventListener(globalEvent, fireProfile);
};

/**
 * Custom sendBeacon function to override ClientProfiler's default sendBeacon so we can call the
 * zillow-web ClientProfile endpoint. We should remove this fallback as soon as the new ZDC service
 * is ready.
 *
 * @param {object} p - params provided by the ClientProfiler when sendBeacon is called
 * @param {string} [p.beaconUrl = '/ui/ClientProfile.htm] - endpoind URL from the ClientProfiler config
 * @param {object} p.eventNameMap - (unused) machine --> human event name map
 * @param {object} p.eventThresholds - (unused) thresholds for each event
 * @param {array}  p.profiles - profiled events
 * @param {object} p.staticBeaconData - static data from the ClientProfiler config
 */
var sendBeaconOverride = function sendBeaconOverride(params) {
    var beaconUrl = params.beaconUrl,
        profiles = params.profiles,
        _params$staticBeaconD = params.staticBeaconData,
        hostId = _params$staticBeaconD.hostId,
        pageName = _params$staticBeaconD.pageName,
        requestId = _params$staticBeaconD.requestId;

    var DEFAULT_BEACON_URL = '/ui/ClientProfile.htm';

    var beaconRequestUrl = [(beaconUrl || DEFAULT_BEACON_URL) + '?pageName=' + pageName, 'hostId=' + hostId, 'requestId=' + requestId, 'profile=' + profiles.join()].join('&');

    if (global.navigator && global.navigator.sendBeacon) {
        global.navigator.sendBeacon(beaconRequestUrl);
    } else {
        var xhr = new global.XMLHttpRequest();
        xhr.open('GET', beaconRequestUrl, false);
        xhr.send();
    }
};

// Initialize ClientProfiler
global.ClientProfiler = new _clientProfilerCore2.default({
    pageName: 'UNKNOWN',
    sendBeaconOverride: sendBeaconOverride
});

addProfileEvent('DOMContentLoaded');
addProfileEvent('load', 'native browser onload');


//////////////////
// WEBPACK FOOTER
// ./lib/client-assets/scripts/clientProfiler.js
// module id = 475
// module chunks = 4